// extracted by mini-css-extract-plugin
module.exports = {"takeoverProceedButton":"TakeoverProceedButton_takeoverProceedButton__MBMZS","loaderContainer":"TakeoverProceedButton_loaderContainer__2dLy7"};